import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { DeleteButton } from './DeleteButton';

const sample: Dictionary<{ label: string; confirm: string }> = {
  pl: { label: 'Usuń cel Wakacje', confirm: 'Usunąć cel „Wakacje”?' },
  en: { label: 'Delete goal Holidays', confirm: 'Delete goal "Holidays"?' },
};

export default {
  kind: 'component',
  title: { pl: 'Przycisk usuwania', en: 'Delete button' },
  description: {
    pl: 'Usunięcie za natywnym `confirm`. Każde usunięcie w tej aplikacji jest natychmiastowe i nieodwracalne, więc wszystkie idą przez ten przycisk. Pytanie ma nazywać usuwaną rzecz. Tutaj potwierdzenie niczego nie usuwa.',
    en: 'A destructive action behind a native `confirm`. Every delete in this app is immediate and cannot be undone, so all of them go through here. The question names the thing being deleted. Confirming here deletes nothing.',
  },
  variants: [
    {
      name: { pl: 'Ikona', en: 'Icon' },
      render: (locale) => (
        <DeleteButton
          label={sample[locale].label}
          confirm={sample[locale].confirm}
          onConfirm={() => {}}
        />
      ),
    },
    {
      name: { pl: 'Zablokowany', en: 'Disabled' },
      render: (locale) => (
        <DeleteButton
          label={sample[locale].label}
          confirm={sample[locale].confirm}
          onConfirm={() => {}}
          disabled
        />
      ),
    },
  ],
} satisfies Story;
